import { render, staticRenderFns } from "./Question24.vue?vue&type=template&id=5b9a4ede&scoped=true&"
import script from "./Question24.vue?vue&type=script&lang=js&"
export * from "./Question24.vue?vue&type=script&lang=js&"
import style0 from "./Question24.vue?vue&type=style&index=0&id=5b9a4ede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a4ede",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VForm,VRadio,VRadioGroup})
